import oRequest from '@/libsV2/request.js';
import route from '@/router/index'

const URL = {
    // 用户交付 接口
    USER_INDEX: "member/index/index", // 用户交付在线首页
    USER_APPINDEX_INDEX: "member/appindex/index", // 用户交付在线首页
    USER_PROJECT_LIST: "member/project/lists", // 用户我的项目列表
    USER_SET_PACT: "member/index/setDefault", // 用户设置默认合同
    USER_TEAM: "member/project/team", // 服务团队
    USER_TEAM_V2: "member/project/teamv2", // 服务团队
    CREATE_LOG: '/statistics/Jiaofustatistics/createlog',//记录访问（操作）日志
    // 能力评分 接口  score
    SCORE_TABLE_HEADER: "hvac/score/pdetail", // 能力评分
    SCORE_TABLE_BOTTOM: "hvac/score/pdlist", // 能力评分 表格数据

    // 能力评分详细
    SCORE_DETAILS_DATE: 'hvac/score/items', // 项目评分详细


    // 业绩在线
    PROIECTTEAM: "member/project/team", // 服务团队

    // 交付在线-订单备忘录
    MEMORANDUM: "contract/index/getInfo",
    // 合同图片
    GET_CONTANT_FILE: "contract/index/getContantFile",
    DOWNLOAD: "contract/index/getContantFile",//合同下载

    //口碑地图周边门店列表
    GETNEARLIST: 'store/map/lists',

    // 体验见搜索
    GETSEARCH: 'hvac/discuss/reportsearchpre',

    MOKAN: '/mokan/index/single',
    // 交付报告app端根据appmob获取用户id
    APPINDEX_UID: '/member/appindex/getuid',
    SHARE_TITLE: '/member/index/baseinfoshare'//获取分享标题
};
export const shareInfoTitle = (data = {}) => {
    return oRequest.getData(URL.SHARE_TITLE, data);
};
export const downloadContract = (data = {}) => {
    return oRequest.getData(URL.DOWNLOAD, data);
};
// 用户交付
export const getMemorandumInfo = (data = {}) => {

    return oRequest.getData(URL.MEMORANDUM, data);
};
export const getUserAppIndex = (data = {}) => {
    return oRequest.getData(URL.USER_APPINDEX_INDEX, data)
}
export const getUserIndex = (data = {}) => {
    return oRequest.getData(URL.USER_INDEX, data)
}
export const getProectList = (data = {}) => {
    return oRequest.getData(URL.USER_PROJECT_LIST, data)
}
export const getSetPact = (data = {}) => {
    return oRequest.getData(URL.USER_SET_PACT, data)
}
export const getTeam = (data = {}) => {
    return oRequest.getData(URL.USER_TEAM, data)
}

export const getTeamV2 = (data = {}) => {
    return oRequest.getData(URL.USER_TEAM_V2, data)
}

// 能力评分
export const getTableHeader = (data = {}) => {
    return oRequest.getData(URL.SCORE_TABLE_HEADER, data)
}
export const getTableBtn = (data = {}) => {
    return oRequest.getData(URL.SCORE_TABLE_BOTTOM, data)
}

// 能力评分详细
export const getDetailsData = (data = {}) => {
    return oRequest.getData(URL.SCORE_DETAILS_DATE, data)
}

// 业绩在线
export const getTeams = (data = {}) => {
    return oRequest.getData(URL.PROIECTTEAM, data)
}

// 门店列表
export const getnearList = (data = {}) => {
    return oRequest.getData(URL.GETNEARLIST, data)
}

// 体验间搜索
export const getsearch = (data = {}) => {
    return oRequest.getData(URL.GETSEARCH, data)
}

// 记录访问（操作）日志
export const createLog = (data = {}) => {
    console.log(route.currentRoute, 'route.currentRoute');
    // 判断是否是app端路径需要修改方法
    const curPath = route.currentRoute.path
    if (curPath.indexOf('/member/v3') > -1) {
        return oRequest.singleAjaxData(URL.CREATE_LOG, data)
    } else {
        return oRequest.getData(URL.CREATE_LOG, data)
    }
}

export const getMokan = (data = {}) => {
    return oRequest.getData(URL.MOKAN, data)
}

// 获取app端用户id
export const getAppUid = (data = {}) => {
    return oRequest.singleAjaxData(URL.APPINDEX_UID, data)
}
